export const NAV = {
  brand: 'nav-brand',
  vaultLink: 'nav-vault-link',
  valuationLink: 'nav-valuation-link',
  bridgeLink: 'nav-bridge-link',
  boardingLink: 'nav-boarding-link',
  loginLink: 'nav-login-link',
  dashboardLink: 'nav-dashboard-link',
  logoutBtn: 'nav-logout-btn',
  mobileToggle: 'nav-mobile-toggle',
};

export const HOME = {
  heroEnterVault: 'hero-enter-vault-btn',
  heroBoarding: 'hero-boarding-btn',
  heroValuation: 'hero-valuation-btn',
};

export const VAULT = {
  filterAll: 'vault-filter-all',
  filterNigeria: 'vault-filter-nigeria',
  filterUSA: 'vault-filter-usa',
  card: (id) => `vault-card-${id}`,
  cardLink: (id) => `vault-card-link-${id}`,
};

export const PROPERTY = {
  back: 'property-back-btn',
  inquire: 'property-inquire-btn',
};

export const VALUATION = {
  propertyType: 'val-property-type',
  location: 'val-location',
  country: 'val-country',
  bedrooms: 'val-bedrooms',
  bathrooms: 'val-bathrooms',
  area: 'val-area',
  condition: 'val-condition',
  notes: 'val-notes',
  submit: 'val-submit-btn',
  resetBtn: 'val-reset-btn',
  resultBlock: 'val-result-block',
};

export const BOARDING = {
  step: (n) => `boarding-step-${n}`,
  nextBtn: 'boarding-next-btn',
  prevBtn: 'boarding-prev-btn',
  submitBtn: 'boarding-submit-btn',
  fullName: 'boarding-full-name',
  email: 'boarding-email',
  phone: 'boarding-phone',
  nationality: 'boarding-nationality',
  residence: 'boarding-residence',
  dob: 'boarding-dob',
  idType: 'boarding-id-type',
  idNumber: 'boarding-id-number',
  investmentCapacity: 'boarding-investment-capacity',
  sourceOfFunds: 'boarding-source-of-funds',
  targetRegion: 'boarding-target-region',
  targetProperty: 'boarding-target-property',
  isPep: 'boarding-is-pep',
  accredited: 'boarding-accredited',
  notes: 'boarding-notes',
  successBlock: 'boarding-success-block',
};

export const AUTH = {
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  fullNameInput: 'auth-fullname-input',
  submitBtn: 'auth-submit-btn',
  switchModeBtn: 'auth-switch-mode-btn',
};

export const FLIP = {
  tabAnalyzer: 'flip-tab-analyzer',
  tabVelocity: 'flip-tab-velocity',
  address: 'flip-address',
  location: 'flip-location',
  country: 'flip-country',
  acquisition: 'flip-acquisition',
  renovation: 'flip-renovation',
  arv: 'flip-arv',
  holding: 'flip-holding',
  closingPct: 'flip-closing-pct',
  sellingPct: 'flip-selling-pct',
  financing: 'flip-financing',
  contingency: 'flip-contingency',
  analyzeBtn: 'flip-analyze-btn',
  resultBlock: 'flip-result-block',
  shieldScore: 'flip-shield-score',
  velocityNeighborhood: 'flip-velocity-neighborhood',
  velocityCountry: 'flip-velocity-country',
  velocityClass: 'flip-velocity-class',
  velocitySubmit: 'flip-velocity-submit',
  velocityResult: 'flip-velocity-result',
};
